export default __webpack_public_path__ + "static/media/Sofia-Pro-Bold.bc190b4b.otf";